module.exports = __webpack_public_path__ + "img/image-launch-vehicle-portrait.36fba639.jpg";